const searchRequestActions = {
  SEARCH_REQUEST_STATE_INIT: 'SEARCH_REQUEST_STATE_INIT',
  SEARCH_REQUEST_PROP_SET: 'SEARCH_REQUEST_PROP_SET',
  SEARCH_REQUEST_PROP_DELETE: 'SEARCH_REQUEST_PROP_DELETE'
};

export default searchRequestActions;